import React from "react";
import { Navigate, useParams } from "react-router-dom";
import { useCompanySettings, useCurrentUser } from "../hooks";
import { Routes } from "../types/NavigationPaths";

interface ProtectedInsightsRouteProps {
  children: React.ReactNode;
}

export const ProtectedInsightsRoute: React.FC<
  ProtectedInsightsRouteProps
> = ({ children }) => {
  const { companyId } = useParams();
  const { isLoading: isUserLoading } = useCurrentUser();
  const { isDataAnalyticsEnabled, isLoading: isSettingsLoading } =
    useCompanySettings({
      companyId: companyId,
    });

  // Show nothing while loading to prevent flash
  if (isUserLoading || isSettingsLoading) {
    return null;
  }

  // Redirect to home if Data Analytics is disabled
  if (!isDataAnalyticsEnabled) {
    return <Navigate replace to={Routes.COMPANY} />;
  }

  return children;
};
